var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-layout"},_vm._l((this.eventList),function(event){return _c('Event',{key:event.id,attrs:{"id":event.id,"title":event.name,"dateStart":event.startDate,"price":event.price,"description":event.description,"hall-type":event.hallType,"img-path":event.image.path}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7bab25","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/EventLayout.vue
// module id = null
// module chunks = 